import { FC } from "react";
import styles from "./Main.module.scss";
import { motion } from "framer-motion";

interface MainProps {
  classess?: string;
}

const text = "Ваша улыбка - наша цель!";

const Main: FC<MainProps> = ({ classess }) => {
  return (
    <div className={styles.Main}>
      <div className={styles.suggestion}>
        <h1 style={{ position: "relative", display: "inline-block" }}>
          {text.split("").map((char, index) => (
            <motion.span
              key={index.toString()}
              style={{ color: "rgba(230, 230, 230, 0)" }}
              initial={{ color: "rgba(230, 230, 230, 0)" }}
              animate={{
                color: "rgba(255, 255, 255, 1)",
                textShadow:
                  "0 0 0 #fff, 0 0 5px #fff, 0 0 15px #fff, 0 0 5px #c8eef3, 0 0 5px #a1f1fc, 0 0 5px #8ee4f0, 0 0 5px #9ef4ff, 0 0 10px #91f2ff",
              }}
              transition={{
                delay: index * 0.03,
                duration: 0.5,
                ease: "easeInOut",
              }}
            >
              {char}
            </motion.span>
          ))}
        </h1>
      </div>
    </div>
  );
};

export default Main;
